document.addEventListener("DOMContentLoaded", function() {
    const quizContainer = document.getElementById("tattoo-quiz");
    if (!quizContainer) return;

    const questions = [
        { text: "Quel style de tatouage préfères-tu ?", options: ["Minimaliste", "Géométrique", "Réaliste", "Traditionnel"] },
        { text: "Quel est ton thème favori ?", options: ["Nature", "Animaux", "Symboles", "Mythologie"] },
        { text: "Quelle taille de tatouage cherches-tu ?", options: ["Petit", "Moyen", "Grand"] },
        { text: "Où veux-tu le placer ?", options: ["Avant-bras", "Épaule", "Poignet", "Dos"] }
    ];

    let answers = [];
    let currentQuestion = 0;

    function showQuestion(index) {
        quizContainer.innerHTML = `
            <div class="quiz-question active">
                <h2>${questions[index].text}</h2>
                <div class="quiz-options">
                    ${questions[index].options.map((option, i) => `<button data-index="${index}" data-answer="${option}">${option}</button>`).join('')}
                </div>
            </div>
        `;

        document.querySelectorAll(".quiz-options button").forEach(button => {
            button.addEventListener("click", function() {
                answers[index] = this.getAttribute("data-answer");
                currentQuestion++;

                if (currentQuestion < questions.length) {
                    showQuestion(currentQuestion);
                } else {
                    showResults();
                }
            });
        });
    }

    function showResults() {
        let filterTags = answers.map(a => a.toLowerCase()).join(" ");
        let productGrid = document.createElement("div");
        productGrid.innerHTML = `
            <h2>Voici les tatouages qui te correspondent :</h2>
            <div id="filtered-results">
                <p>Chargement des résultats...</p>
            </div>
            <button onclick="location.reload()">Recommencer</button>
        `;
        quizContainer.innerHTML = "";
        quizContainer.appendChild(productGrid);

        fetch(`/collections/all?section_id=collection-template&q=${filterTags}`)
            .then(response => response.text())
            .then(html => {
                let parser = new DOMParser();
                let doc = parser.parseFromString(html, "text/html");
                let products = doc.querySelectorAll(".product-item");
                let resultsContainer = document.getElementById("filtered-results");
                resultsContainer.innerHTML = "";

                products.forEach(product => {
                    let clone = product.cloneNode(true);
                    resultsContainer.appendChild(clone);
                });

                if (products.length === 0) {
                    resultsContainer.innerHTML = "<p>Aucun tatouage trouvé avec ces critères. 😞</p>";
                }
            });
    }

    showQuestion(0);
});

document.addEventListener("DOMContentLoaded", function() {
    console.log("Tattoo Finder Script Chargé !");
    let quiz = document.getElementById("tattoo-quiz");

    if (!quiz) {
        console.error("Tattoo Finder introuvable !");
    } else {
        console.log("Tattoo Finder trouvé et affiché !");
        quiz.style.display = "block"; // Force l'affichage JS au cas où CSS bloque
    }
});

document.addEventListener("shopify:section:load", function() {
    console.log("Shopify section reloaded. Vérification du Tattoo Finder...");
    let quiz = document.getElementById("tattoo-quiz");
    if (quiz) {
        quiz.style.display = "block";
    }
});
setInterval(function() {
    let quiz = document.getElementById("tattoo-quiz");
    if (quiz) {
        let display = window.getComputedStyle(quiz).display;
        if (display === "none") {
            console.warn("Shopify ou un autre script masque #tattoo-quiz !");
            quiz.style.display = "block";
            quiz.style.visibility = "visible";
            quiz.style.opacity = "1";
        }
    }
}, 500);
document.addEventListener("shopify:section:load", function() {
    console.log("Shopify AJAX detected! Reloading quiz content...");
    initTattooQuiz(); // Remplace par le nom de ta fonction si elle existe
});

console.log("tattoo-quiz.js is loaded!");
